import Vue from 'vue';
import Http from 'axios';
import Swiper from '@app/components/Layout/Swiper.vue';
import VideoComponent from '@app/components/Video.vue';
export default Vue.extend({
    components: {
        Swiper: Swiper,
        VideoComponent: VideoComponent
    },
    props: {
        block: Object,
    },
    data: function () { return ({
        projects: []
    }); },
    created: function () {
        var _this = this;
        Http.get("/api/reference/project").then(function (res) {
            _this.projects = res.data.slice(0, 15);
        });
    },
    methods: {}
});
